import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WorksCategoriesApi from '@/services/apiServiceModules/worksCategoriesApi'

const worksCategoriesApi = new WorksCategoriesApi()

export default class WorksCategoriesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORKS_CATEGORIES, worksCategoriesApi, {
			useCache: true,
		})
	}
}
